import intlTelInput from 'intl-tel-input';

const form = document.querySelector('#contactForm');

window.addEventListener('DOMContentLoaded', () => {
  validateInputs();

  if (form) {
    selectsHandle();
    countryCodeHandle();
  }
});

form?.addEventListener('submit', e => {
  e.preventDefault();
  e.stopPropagation();
  e.target.classList.add('form--sending');

  const inputs = form.querySelectorAll(
    'input,textarea,select');
  const contactData = new FormData(form);

  Object.values(inputs).map(item => {
    if (item.getAttribute('name') === 'telephone') {
      contactData[item.getAttribute('name')] = "+" + item.dataset.dialCode + item.value;
    } else if(item.getAttribute('name') === 'subject') {
      contactData[item.getAttribute('name')] = document.querySelector(`select#subject option[value="${item.value}"]`).innerText;
    } else if (item.getAttribute('name') === 'file') {
      contactData[item.getAttribute('name')] = item.files[0];
    } else {
      contactData[item.getAttribute('name')] = item.value;
    }
  });



  const inputError = document.querySelector('.input--error');

  if (!inputError) {
    fetch('/wp-json/contact/v1/send', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',//multipart/form-data
      },
      body: JSON.stringify(contactData),
    }).then(async resp => {
      console.log(resp.status);

      if (resp.status === 200) {
        const inputToFlush = form.querySelectorAll(
          'input:not(#pardot_extra_field, #lead_source, #retURL, #oid, #Form_Source__c, #utmsource__c, #fileDownload, #articleTitle),textarea,select');

        Object.values(inputToFlush).map(input => {
          input.value = '';
          input.classList.remove('edited');
        });

        window.scrollTo(0, 0);

        e.target.classList.remove('form--sending');
        e.target.classList.add('form--sent');
      } else {
        window.scrollTo(0, 0);
        e.target.classList.remove('form--sending');
        e.target.classList.add('form--error');
      }
    });
  }
  else {
    inputError.scrollIntoView();
  }
});

//Disable enter for messages
const textArea = document.querySelectorAll('textarea');
Object.values(textArea).map(el =>
  el.addEventListener('keydown', e => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      return false;
    }
  }),
);

Object.values(document.querySelectorAll('form input, form select, form textarea')).map(item => {
  const events = ['blur', 'keyup'];

  events.map(event => {
    item.addEventListener(event, () => {
      item.classList.toggle('edited', item.value !== '');
    });
  });
});

// Check input with patterns
const validateInputs = () => {
  const inputs = document.querySelectorAll('input[data-pattern]');

  Object.values(inputs).map(input => {
    const pattern = input.dataset.pattern;
    const regexp = new RegExp(pattern, 'g');

    input.addEventListener('blur', () => {
      if (input.value !== '') {
        input.classList.toggle('input--error', !input.value.match(regexp));
      }
      else {
        input.classList.remove('input--error');
      }
    });

    input.addEventListener('keyup', () => {
      if (input.value.match(regexp) || input.value === '') {
        input.classList.remove('input--error');
      }
    });
  });

  Object.values(document.querySelectorAll('form input, form select, form textarea')).map(item => {
    const events = ['blur'];

    events.map(event => {
      item.addEventListener(event, () => {
        item.classList.toggle('edited', item.value !== '');
      });
    });
  });
};

const countryCodeHandle = () => {
  const input = document.querySelector('#telephone');
  intlTelInput(input, {
    loadUtils: () => import('intl-tel-input/build/js/utils'),
    initialCountry: 'fr',
    strictMode: true,
    customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
      const telephone = document.querySelector('input#telephone');
      telephone.dataset.dialCode = selectedCountryData.dialCode;
      return selectedCountryPlaceholder;
    },
    //utilsScript: "/intl-tel-input/js/utils.js?1733052783337" // just for formatting/placeholders etc
  });
};

const selectsHandle = () => {
  const recipient = document.querySelector('#recipient');
  const subjects = document.querySelector('#subject');
  const offer = document.querySelector('#offer');

  if (subjects) {
    subjects.addEventListener('change', e => {
      [...subjects.selectedOptions].map(option => {
        recipient.value = option.dataset.recipient

        offer.closest('.select--wrapper').style.display = option.value === 'offer' ? 'flex' : 'none';
        offer.required = option.value === 'offer';
        offer.value = '';
      });
    })
  }
}
